import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { faSearch, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueueSelectionPurpose } from 'src/app/samwebDescription/samwin/QueueSelectionPurpose';
import {
   CompleteQueueSelectionProcess,
   EndQueueSelectionProcess,
   QueueSelectionSearchTextChanged,
   QueueSelectionSelectQueue,
} from 'src/app/store/samwin/queue-selection-dialog/queue-selection-dialog.actions';
import { QueueSelectionDialogSelectors } from 'src/app/store/samwin/queue-selection-dialog/queue-selection-dialog.selectors';
import { SamwinCallInfoRemoteDto } from 'src/generated/signalR/samwin-call-info-remote-dto';
import { QueueShortInfoRemoteDto } from 'src/generated/swagger';

@Component({
   selector: 'samweb-queue-selection-dialog',
   templateUrl: './queue-selection-dialog.component.html',
   styleUrls: ['./queue-selection-dialog.component.scss'],
})
export class QueueSelectionDialogComponent implements OnInit, AfterViewInit {
   public noDataIcon: IconDefinition = faSearch;

   @Select(QueueSelectionDialogSelectors.getPurpose)
   public purpose$: Observable<QueueSelectionPurpose>;

   @Select(QueueSelectionDialogSelectors.isQueueSelectionInProgress)
   public isQueueSelectionInProgress$: Observable<boolean>;

   @Select(QueueSelectionDialogSelectors.isQueueSelected)
   public isQueueSelected$: Observable<boolean>;

   @Select(QueueSelectionDialogSelectors.isLoadingSelectableQueues)
   public isLoadingSelectableQueues$: Observable<boolean>;

   @Select(QueueSelectionDialogSelectors.getQueueContextData)
   public contextData$: Observable<any>;

   public callInfo$: Observable<SamwinCallInfoRemoteDto>;

   @Select(QueueSelectionDialogSelectors.getSelectedQueue)
   public selectedQueue$: Observable<QueueShortInfoRemoteDto>;

   @Select(QueueSelectionDialogSelectors.getFilteredSelectableQueues)
   public filteredSelectableQueues$: Observable<QueueShortInfoRemoteDto[]>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.callInfo$ = this.contextData$.pipe(
         map((x) => {
            if (_.has(x, 'info')) {
               return x;
            }
            return null;
         })
      );
   }

   ngAfterViewInit(): void {}

   selectQueue(queue: QueueShortInfoRemoteDto) {
      this.store.dispatch(new QueueSelectionSelectQueue(queue));
   }

   searchTextChanged(value: string) {
      this.store.dispatch(new QueueSelectionSearchTextChanged(value));
   }

   cancel(): void {
      this.store.dispatch(new EndQueueSelectionProcess());
   }

   ok(): void {
      this.store.dispatch(new CompleteQueueSelectionProcess());
   }

   @HostListener('keydown', ['$event'])
   private onKeyDown(eventData: KeyboardEvent) {
      eventData.stopPropagation();
   }

   @HostListener('keyup', ['$event'])
   private onKeyUp(eventData: KeyboardEvent) {
      eventData.stopPropagation();
   }
}
